export default __webpack_public_path__ + "static/media/evan_square.109dc36c.jpg";